export default __webpack_public_path__ + "static/media/Instagram 3d logo.278e7f29.svg";